import { useState } from "react";
import "./pages.css";
function AdminPage({ blogs, setBlogs, setPage }) {
  const [loggedIn, setLoggedIn] = useState(false);

  const [creds, setCreds] = useState({ u: "", p: "" });
  const [form, setForm] = useState({ title: "", content: "", img: "" });
  const [saved, setSaved] = useState(false);

  const login = async () => {
    console.log("login attempt");
    const res = await fetch(
      "https://nastyauthenticbackend.onrender.com/admin/login",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: creds.u, password: creds.p }),
      },
    );

    const data = await res.json();
    if (!data.success) {
      alert(`${data.message}`);
      return;
    }

    const token = data.token;
    localStorage.setItem("adminToken", token);
    setLoggedIn(true);
  };

  const publish = async () => {
    if (!form.title || !form.content) return;

    const excerpt = form.content.slice(0, 110) + "...";
    const image =
      form.img ||
      "https://images.unsplash.com/photo-1504450758481-7338eba7524a?w=800&q=80";

    try {
      const res = await fetch(
        "https://nastyauthenticbackend.onrender.com/admin/blog",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
          },
          body: JSON.stringify({
            title: form.title.toUpperCase(),
            content: form.content,
            excerpt,
            image,
          }),
        },
      );

      const data = await res.json();

      if (!data.success) {
        alert(data.message);
        return;
      }

      setBlogs((p) => [data.blog, ...p]);
      setSaved(true);
      setForm({ title: "", content: "", img: "" });
      setTimeout(() => setSaved(false), 2000);
    } catch (e) {
      console.log("Error publishing blog:", e);
      alert("Failed to publish blog");
    }
  };
  if (!loggedIn)
    return (
      <div className="auto">
        <p className="section-title">ADMIN</p>
        <h1 className="bigTitle">LOGIN</h1>
        <label className="admin-label">USERNAME</label>
        <input
          value={creds.u}
          onChange={(e) => setCreds((p) => ({ ...p, u: e.target.value }))}
          placeholder="admin"
        />
        <label className="admin-label">PASSWORD</label>
        <input
          type="password"
          //   style={S.adminInput}
          value={creds.p}
          onChange={(e) => setCreds((p) => ({ ...p, p: e.target.value }))}
          placeholder="••••••••"
          onKeyDown={(e) => e.key === "Enter" && login()}
        />
        <button className="admin-publishBtn" onClick={login}>
          ENTER →
        </button>
        <p
          style={{
            marginTop: 20,
            fontSize: 10,
            color: "#333",
            fontFamily: "monospace",
          }}
        >
          HINT: admin / nasty2025
        </p>
      </div>
    );
  return (
    <div className="admin-page">
      <div style={{ maxWidth: 760, margin: "0 auto" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: 36,
          }}
        >
          <div>
            <p className="section-title">ADMIN PANEL</p>
            <h1 className="bigTitle">NEW POST</h1>
          </div>
          <button
            className="admin-publishBtn"
            onClick={() => setPage("blog")}
            // style={{
            //   ...S.rmBtn,
            //   fontSize: 10,
            //   letterSpacing: "0.15em",
            //   color: "#444",
            // }}
          >
            ← VIEW BLOG
          </button>
        </div>
        <label className="admin-label">TITLE</label>
        <input
          //   style={S.adminInput}
          value={form.title}
          onChange={(e) => setForm((p) => ({ ...p, title: e.target.value }))}
          placeholder="Post title..."
        />
        <label className="admin-label">COVER IMAGE URL</label>
        <input
          //   style={S.adminInput}
          value={form.img}
          onChange={(e) => setForm((p) => ({ ...p, img: e.target.value }))}
          placeholder="https://..."
        />
        {form.img && (
          <img
            src={form.img}
            alt=""
            style={{
              width: "100%",
              height: 220,
              objectFit: "cover",
              marginBottom: 14,
            }}
            onError={(e) => (e.target.style.display = "none")}
          />
        )}
        <label className="admin-label">CONTENT</label>
        <textarea
          //   style={S.adminTextarea}
          value={form.content}
          onChange={(e) => setForm((p) => ({ ...p, content: e.target.value }))}
          placeholder="Write your post..."
        />
        <button className="admin-publishBtn" onClick={publish}>
          {saved ? "✓ PUBLISHED" : "PUBLISH POST"}
        </button>
        <div
          style={{ marginTop: 52, borderTop: "1px solid #111", paddingTop: 36 }}
        >
          <p>ALL POSTS ({blogs.length})</p>
          {blogs.map((b) => (
            <div
              key={b.id}
              style={{
                display: "flex",
                gap: 14,
                alignItems: "center",
                padding: "14px 0",
                borderBottom: "1px solid #0f0f0f",
              }}
            >
              <img
                src={b.image}
                alt=""
                style={{ width: 56, height: 56, objectFit: "cover" }}
              />
              <div>
                <p
                  style={{
                    margin: "0 0 3px",
                    fontSize: 11,
                    letterSpacing: "0.1em",
                    fontWeight: 700,
                  }}
                >
                  {b.title}
                </p>
                <p
                  style={{
                    margin: 0,
                    fontSize: 10,
                    color: "#333",
                    fontFamily: "monospace",
                  }}
                >
                  {b.date}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AdminPage;
